export default __webpack_public_path__ + "static/pic-4-cee9a3acc94c77f78d7d96a031c5a7ff.png";